import * as React from 'react';
import Svg, {
    Defs, LinearGradient,
    Path,
    Stop,
} from 'react-native-svg';

export const IcDownloadAndroid = () => (
    <Svg
        width={146}
        height={53}
        fill="none"
    >
        <Path
            fill="#fff"
            d="M51.125 16.56c0 .785-.216 1.472-.755 1.962-.648.588-1.403.883-2.373.883-.971 0-1.727-.295-2.374-.883-.647-.589-.97-1.275-.97-2.158 0-.882.323-1.569.97-2.157.648-.589 1.403-.883 2.373-.883.432 0 .863.098 1.295.294.431.197.755.393.97.687l-.539.49c-.431-.49-.97-.686-1.726-.686-.647 0-1.294.196-1.726.686-.539.393-.755.98-.755 1.667s.216 1.275.755 1.668c.54.392 1.08.686 1.726.686.756 0 1.295-.196 1.834-.686.324-.295.54-.687.54-1.177h-2.373v-.785h3.128v.393Zm4.962-2.451h-2.913v1.863h2.697v.687h-2.697v1.863h2.913v.784h-3.776v-5.884h3.776v.687Zm3.56 5.197h-.863V14.11H56.95v-.687h4.53v.687h-1.833v5.197Zm4.962 0v-5.884h.863v5.884h-.863Zm4.531 0h-.863V14.11h-1.834v-.687h4.423v.687h-1.834v5.197h.108Zm10.248-.784c-.647.588-1.402.883-2.373.883-.97 0-1.726-.295-2.373-.883-.647-.589-.971-1.275-.971-2.158 0-.882.323-1.569.97-2.157.648-.589 1.403-.883 2.374-.883.97 0 1.726.294 2.373.883.647.588.971 1.275.971 2.157 0 .883-.323 1.57-.97 2.158Zm-4.099-.49c.431.392 1.079.686 1.726.686s1.294-.196 1.726-.686c.431-.393.755-.981.755-1.668 0-.686-.216-1.275-.755-1.667-.431-.392-1.079-.686-1.726-.686s-1.294.196-1.726.686c-.431.393-.755.98-.755 1.667s.216 1.275.755 1.668Zm6.257 1.274v-5.884h.97l3.129 4.61v-4.61h.863v5.884h-.863l-3.344-4.805v4.805h-.755ZM73.456 27.937c-2.589 0-4.638 1.766-4.638 4.217 0 2.354 2.05 4.217 4.638 4.217 2.59 0 4.64-1.765 4.64-4.217 0-2.55-2.05-4.217-4.64-4.217Zm0 6.669c-1.402 0-2.589-1.079-2.589-2.55 0-1.47 1.187-2.55 2.59-2.55 1.402 0 2.589.981 2.589 2.55 0 1.471-1.187 2.55-2.59 2.55Zm-10.032-6.669c-2.589 0-4.639 1.766-4.639 4.217 0 2.354 2.05 4.217 4.639 4.217 2.589 0 4.639-1.765 4.639-4.217 0-2.55-2.05-4.217-4.639-4.217Zm0 6.669c-1.402 0-2.589-1.079-2.589-2.55 0-1.47 1.187-2.55 2.589-2.55s2.589.981 2.589 2.55c0 1.471-1.187 2.55-2.589 2.55ZM51.45 29.212v1.765h4.639c-.108.981-.54 1.766-1.08 2.256-.647.589-1.725 1.275-3.56 1.275-2.912 0-5.07-2.06-5.07-4.707 0-2.648 2.266-4.708 5.07-4.708 1.511 0 2.698.589 3.56 1.275l1.403-1.275c-1.187-.98-2.697-1.765-4.854-1.765-3.884 0-7.228 2.942-7.228 6.473 0 3.53 3.344 6.472 7.228 6.472 2.157 0 3.667-.588 4.962-1.863 1.294-1.177 1.726-2.844 1.726-4.119 0-.392 0-.785-.108-1.079H51.45Zm48.975 1.373c-.431-.98-1.51-2.648-3.883-2.648-2.374 0-4.315 1.668-4.315 4.217 0 2.354 1.941 4.217 4.53 4.217 2.05 0 3.345-1.177 3.776-1.863l-1.51-.98c-.54.686-1.187 1.176-2.266 1.176-1.078 0-1.726-.392-2.265-1.275l6.149-2.354-.216-.49Zm-6.257 1.373c0-1.569 1.403-2.452 2.374-2.452.755 0 1.51.393 1.726.883l-4.1 1.57Zm-5.07 4.021h2.05V23.72h-2.05V35.98Zm-3.236-7.159c-.54-.49-1.402-.98-2.481-.98-2.265 0-4.423 1.863-4.423 4.216 0 2.354 2.05 4.12 4.423 4.12 1.079 0 1.942-.491 2.373-.982h.108v.589c0 1.569-.97 2.452-2.481 2.452-1.187 0-2.05-.785-2.265-1.471l-1.726.686c.539 1.079 1.834 2.452 4.099 2.452 2.373 0 4.315-1.275 4.315-4.315v-7.454h-1.942v.687Zm-2.373 5.786c-1.403 0-2.59-1.079-2.59-2.55 0-1.47 1.188-2.55 2.59-2.55s2.481 1.08 2.481 2.55c0 1.471-1.079 2.55-2.481 2.55ZM109.81 23.72h-4.854V35.98h2.05v-4.61h2.804c2.266 0 4.423-1.47 4.423-3.824s-2.157-3.825-4.423-3.825Zm.108 5.885h-2.912v-4.217h2.912c1.511 0 2.374 1.176 2.374 2.059-.108 1.079-.971 2.158-2.374 2.158Zm12.406-1.766c-1.51 0-3.02.589-3.56 1.864l1.834.686c.432-.686 1.079-.883 1.834-.883 1.079 0 2.05.589 2.157 1.57v.098c-.323-.197-1.186-.49-2.049-.49-1.942 0-3.884.98-3.884 2.745 0 1.667 1.618 2.746 3.344 2.746 1.403 0 2.05-.588 2.589-1.177h.108v.981h1.942v-4.707c-.216-2.158-2.05-3.433-4.315-3.433Zm-.216 6.767c-.647 0-1.618-.294-1.618-1.079 0-.98 1.187-1.275 2.158-1.275.863 0 1.294.197 1.834.393-.216 1.176-1.295 1.961-2.374 1.961Zm11.327-6.473-2.265 5.296h-.108l-2.373-5.296h-2.158l3.56 7.454-2.05 4.119h2.05l5.502-11.573h-2.158Zm-18.123 7.846h2.05V23.72h-2.05V35.98Z"
        />

        <Path
            fill="url(#ic_android_a)"
            d="M13.395 13.69c-.308.313-.41.833-.41 1.457v22.986c0 .624.205 1.144.512 1.456l.103.104 12.717-12.897v-.208L13.395 13.69Z"
        />

        <Path
            fill="url(#ic_android_b)"
            d="M30.42 31.163 26.215 26.9v-.312l4.205-4.265.102.104 5.026 2.913c1.436.832 1.436 2.184 0 3.016l-5.128 2.808Z"
        />

        <Path
            fill="url(#ic_android_c)"
            d="m30.522 31.064-4.307-4.369-12.82 13.002c.512.52 1.23.52 2.153.104l14.974-8.737Z"
        />

        <Path
            fill="url(#ic_android_d)"
            d="m30.522 22.325-14.974-8.633c-.923-.52-1.64-.417-2.153.104l12.82 12.897 4.307-4.369Z"
        />

        <Path
            fill="#0C0C0E"
            d="m30.42 30.957-14.872 8.529c-.82.52-1.538.416-2.05 0l-.103.104.102.104c.513.416 1.23.52 2.051 0l14.872-8.737Z"
            opacity={0.2}
        />

        <Path
            fill="#0C0C0E"
            d="M13.395 39.489c-.308-.312-.41-.832-.41-1.456v.104c0 .624.205 1.144.512 1.456v-.104h-.102Zm22.153-11.441L30.42 30.96l.102.104 5.026-2.913c.718-.416 1.026-.936 1.026-1.456 0 .52-.41.936-1.026 1.352Z"
            opacity={0.12}
        />

        <Path
            fill="#fff"
            d="m15.548 13.795 20 11.545c.615.416 1.026.832 1.026 1.353 0-.52-.308-1.04-1.026-1.457l-20-11.545c-1.435-.832-2.564-.208-2.564 1.456v.104c0-1.56 1.129-2.288 2.564-1.456Z"
            opacity={0.25}
        />

        <Defs>
            <LinearGradient
                id="ic_android_a"
                x1={25.087}
                x2={7.632}
                y1={14.949}
                y2={32.159}
                gradientUnits="userSpaceOnUse"
            >
                <Stop stopColor="#00A0FF" />

                <Stop offset={0.007} stopColor="#00A1FF" />

                <Stop offset={0.26} stopColor="#00BEFF" />

                <Stop offset={0.512} stopColor="#00D2FF" />

                <Stop offset={0.76} stopColor="#00DFFF" />

                <Stop offset={1} stopColor="#00E3FF" />
            </LinearGradient>

            <LinearGradient
                id="ic_android_b"
                x1={37.429}
                x2={12.612}
                y1={26.692}
                y2={26.692}
                gradientUnits="userSpaceOnUse"
            >
                <Stop stopColor="#FFE000" />

                <Stop offset={0.409} stopColor="#FFBD00" />

                <Stop offset={0.775} stopColor="orange" />

                <Stop offset={1} stopColor="#FF9C00" />
            </LinearGradient>

            <LinearGradient
                id="ic_android_c"
                x1={28.191}
                x2={4.523}
                y1={29.083}
                y2={52.422}
                gradientUnits="userSpaceOnUse"
            >
                <Stop stopColor="#FF3A44" />

                <Stop offset={1} stopColor="#C31162" />
            </LinearGradient>

            <LinearGradient
                id="ic_android_d"
                x1={10.212}
                x2={20.782}
                y1={6.074}
                y2={16.496}
                gradientUnits="userSpaceOnUse"
            >
                <Stop stopColor="#32A071" />

                <Stop offset={0.069} stopColor="#2DA771" />

                <Stop offset={0.476} stopColor="#15CF74" />

                <Stop offset={0.801} stopColor="#06E775" />

                <Stop offset={1} stopColor="#00F076" />
            </LinearGradient>
        </Defs>
    </Svg>
);
